import { lighten } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

export const COLUMN_WIDTH = 275

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateRows: '38px 1fr',
    gridTemplateColumns: 'auto',
    marginRight: '0.5rem',
    borderRadius: '0.5rem',
    minWidth: `${COLUMN_WIDTH}px`,
    width: `${COLUMN_WIDTH}px`,
    maxWidth: `${COLUMN_WIDTH}px`,
    height: 'calc(100svh - 11rem)',
    background: 'white',

    '&:last-child': {
      marginRight: '0'
    },

    [theme.breakpoints.down('md')]: {
      height: 'calc(100svh - 12.5rem)'
    },

    [theme.breakpoints.down(371)]: {
      height: 'calc(100svh - 13.5rem)'
    }
  },

  over: {
    background: theme.palette.secondary.main
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '0.5rem 0.5rem 0 0',
    padding: '0.5rem',
    background: '#E4E8EA'
  },

  name: {
    maxWidth: `${COLUMN_WIDTH - 25}px`,
    fontSize: theme.size.base
  },

  namePrivate: {
    color: lighten('#185c7d', 0.3)
  },

  namePublic: {
    color: theme.palette.primary.main
  },

  nameNone: {
    color: '#959595'
  },

  loadButton: {
    marginLeft: 'auto',
    marginRight: 'auto'
  }
}))

export default useStyles
